import { IGetAllOperationPlansSingleResponse, IGetSingleOperationPlanDashboardResponse } from 'types/api/operationsPlansApi.interface'

const hoursAgo = (h: number) => new Date(Date.now() - h * 3600000).toISOString()
const daysAgo = (d: number) => hoursAgo(d * 24)

export const DEMO_PLANS: IGetAllOperationPlansSingleResponse[] = [
  {
    id: 90001,
    name: 'North Pit Extraction Plan',
    code: 'NPX-001',
    priority: 3,
    site: { id: 1, name: 'North Pit' },
    departmentKey: 'mining',
    departmentName: 'Mining',
    owner: { id: 1, firstName: 'Kwame', lastName: 'Asante' },
    zoneScopeLevel: 4,
    objective: 'Extract 50kt ore from North Pit benches 4-6',
    boardVisibility: 2,
    targetUnit: { id: 1, name: 't' },
    targetValue: 50000,
    currentValue: 23400,
    costPerUnit: 4.1,
    plannedCostPerUnit: 3.95,
    status: 2,
    autoPauseOnL3Plus: true,
    queueHealth: 1,
    updatedAt: hoursAgo(2),
  },
  {
    id: 90002,
    name: 'Waste Stripping Phase 2',
    code: 'WSP-002',
    priority: 3,
    site: { id: 1, name: 'North Pit' },
    departmentKey: 'mining',
    departmentName: 'Mining',
    owner: { id: 7, firstName: 'Kofi', lastName: 'Adjei' },
    zoneScopeLevel: 4,
    objective: 'Strip 400,000 m³ of overburden ahead of bench 7 mining',
    boardVisibility: 3,
    targetUnit: { id: 5, name: 'm³' },
    targetValue: 400000,
    currentValue: 186000,
    costPerUnit: 4.22,
    plannedCostPerUnit: 4,
    status: 2,
    autoPauseOnL3Plus: true,
    queueHealth: 1,
    updatedAt: hoursAgo(5),
  },
  {
    id: 90003,
    name: 'Block B Drill & Blast',
    code: 'DBL-014',
    priority: 4,
    site: { id: 2, name: 'Block B' },
    departmentKey: 'mining',
    departmentName: 'Mining',
    owner: { id: 2, firstName: 'Ama', lastName: 'Owusu' },
    zoneScopeLevel: 3,
    objective: 'Drill and charge 220 blast holes on Block B level 3',
    boardVisibility: 2,
    targetUnit: { id: 2, name: 'holes' },
    targetValue: 220,
    currentValue: 96,
    costPerUnit: 4.05,
    plannedCostPerUnit: 3.9,
    status: 2,
    autoPauseOnL3Plus: true,
    queueHealth: 2,
    updatedAt: hoursAgo(8),
  },
  {
    id: 90004,
    name: 'Haul Road 3 Maintenance',
    code: 'HRM-007',
    priority: 2,
    site: { id: 3, name: 'Haul Road 3' },
    departmentKey: 'mining',
    departmentName: 'Mining',
    owner: { id: 3, firstName: 'Yaw', lastName: 'Mensah' },
    zoneScopeLevel: 2,
    objective: 'Resurface and grade 1,800 m of haul road segment 3',
    boardVisibility: 1,
    targetUnit: { id: 3, name: 'm' },
    targetValue: 1800,
    currentValue: 640,
    costPerUnit: 4.12,
    plannedCostPerUnit: 3.95,
    status: 3,
    autoPauseOnL3Plus: false,
    queueHealth: 1,
    updatedAt: daysAgo(1),
  },
  {
    id: 90005,
    name: 'Conveyor CV-2 Overhaul',
    code: 'CVO-022',
    priority: 3,
    site: { id: 4, name: 'Processing Plant' },
    departmentKey: 'plant',
    departmentName: 'Processing Plant',
    owner: { id: 4, firstName: 'Efua', lastName: 'Boateng' },
    zoneScopeLevel: 1,
    objective: 'Replace CV-2 idlers and splice the belt',
    boardVisibility: 3,
    targetUnit: { id: 4, name: 'tasks' },
    targetValue: 24,
    currentValue: 0,
    costPerUnit: 6.8,
    plannedCostPerUnit: 7,
    status: 1,
    autoPauseOnL3Plus: false,
    queueHealth: 1,
    updatedAt: hoursAgo(30),
  },
  {
    id: 90006,
    name: 'South Sump Dewatering',
    code: 'DWS-005',
    priority: 2,
    site: { id: 5, name: 'South Sump' },
    departmentKey: 'mining',
    departmentName: 'Mining',
    owner: { id: 5, firstName: 'Kojo', lastName: 'Antwi' },
    zoneScopeLevel: 4,
    objective: 'Pump 12,000 m³ to keep South Sump water level below 4 m',
    boardVisibility: 1,
    targetUnit: { id: 5, name: 'm³' },
    targetValue: 12000,
    currentValue: 9100,
    costPerUnit: 4.03,
    plannedCostPerUnit: 3.95,
    status: 2,
    autoPauseOnL3Plus: true,
    queueHealth: 1,
    updatedAt: hoursAgo(3),
  },
  {
    id: 90007,
    name: 'Crusher Liner Replacement',
    code: 'CLR-031',
    priority: 1,
    site: { id: 4, name: 'Processing Plant' },
    departmentKey: 'plant',
    departmentName: 'Processing Plant',
    owner: { id: 6, firstName: 'Abena', lastName: 'Dankwa' },
    zoneScopeLevel: 1,
    objective: 'Swap primary crusher mantle and concave',
    boardVisibility: 2,
    targetUnit: { id: 4, name: 'tasks' },
    targetValue: 18,
    currentValue: 18,
    costPerUnit: 7.1,
    plannedCostPerUnit: 7,
    status: 4,
    autoPauseOnL3Plus: false,
    queueHealth: 1,
    updatedAt: daysAgo(4),
  },
]

export const DEMO_PLAN_DASHBOARD = {
  id: 90001,
  name: 'North Pit Extraction Plan',
  code: 'NPX-001',
  status: 2,
  createdAt: daysAgo(12),
  updatedAt: hoursAgo(2),
  tasksGeneratedCount: 184,
  tasksCompletedCount: 86,
  queueDepth: 26,
  workersActiveCount: 28,
  progressPercent: 47,
  targetBudgetCost: 105240,
  targetCurrencyCode: '$',
  costPerUnit: 4.1,
  costToDate: 95940,
  budgetRemaining: 9300,
  fuelCostToDate: 96700,
  fuelLitresToDate: 7800,
  phases: [
    { id: 1, name: 'Drilling', executableType: 1, taskCycleTemplate: { id: 1, name: 'Bench Drilling Cycle' }, status: 3 },
    { id: 2, name: 'Blasting', executableType: 3, processTemplate: { id: 2, name: 'Blast Sequence' }, status: 2 },
    { id: 3, name: 'Loading', executableType: 1, taskCycleTemplate: { id: 3, name: 'Excavator Loading Cycle' }, status: 2 },
    { id: 4, name: 'Hauling', executableType: 2, workflowTemplate: { id: 4, name: 'Haul Cycle Workflow' }, status: 1 },
  ],
  horizon: {
    horizonType: 2,
    schedulerRunFreqMin: 15,
    replenishThreshold: 20,
    maxQueueSize: 50,
    pendingQueueCount: 26,
    queueHealth: 1,
  },
} as unknown as IGetSingleOperationPlanDashboardResponse
